import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PropTypes from 'prop-types';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Autoplay, Navigation, Pagination} from 'swiper';
import 'swiper/swiper.scss';
import {Container, Grid} from '@material-ui/core';
import {S3_HOST} from '../../../enviroment';

SwiperCore.use([Autoplay, Navigation, Pagination]);

const useStyles = makeStyles((theme) => ({
  root: {
    '& .swiper-slide': {
      height: 'auto !important',
    },
    '& img': {
      width: '100%',
      height: '100%',
    },
  },
  bannerPromo: {
    background: 'linear-gradient(90deg, rgba(231,90,41,1) 0%, rgba(119,52,186,1) 50%, rgba(30,119,235,1) 100%)',
    paddingTop: 30,
    '@media (max-width: 600px)': {
      background: 'linear-gradient(173deg, rgba(231,90,41,1) 0%, rgba(119,52,186,1) 50%, rgba(30,119,235,1) 100%)',
    },
  },
  itemsBanner: {
    paddingLeft: 20,
    '@media (max-width: 600px)': {
      paddingLeft: 0,
    },
  },
  ofertasPromo: {
    width: '100%',
    '@media (max-width: 600px)': {
      height: '100%',
      width: 'auto',
      marginTop: 30,
    },
  },
}));

LayoutPublish.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default function LayoutPublish({data}) {
  const classes = useStyles();
  const isMobil = useMediaQuery('(max-width:767px)');

  if (!data.length) {
    return <></>;
  }

  return (
    <div className={classes.bannerPromo}>
      <Container>
        <Grid container {...(isMobil ? {direction: 'column-reverse'} : {})}>
          <Grid item sm={9} xs={12} className={classes.itemsBanner}>
            <div className={classes.root}>
              <Swiper
                key={isMobil ? 'banner-mobil' : 'banner'}
                autoplay={{delay: 10000}}
                spaceBetween={20}
                slidesPerView={isMobil ? 1 : 3}
                {...(!isMobil ? {} : {pagination: true})}
              >
                {data.map((item, i) => (
                  <SwiperSlide key={i}>
                    <a href={item.url || '#'}>
                      <img src={`${S3_HOST}/${isMobil ? item.path_movile : item.path_desktop}`} alt="" />
                    </a>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
